(function () {
  function qs(sel, root = document) { return root.querySelector(sel); }
  function qsa(sel, root = document) { return Array.from(root.querySelectorAll(sel)); }

  async function addItems(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    });

    if (!res.ok) {
      let msg = 'Could not add gift + product. Please try again.';
      try {
        const err = await res.json();
        msg = err?.description || err?.message || msg;
      } catch (e) {
        msg = await res.text();
      }
      throw new Error(msg);
    }
    return res.json();
  }

  function waitNextFrames(count = 2) {
    return new Promise((resolve) => {
      const step = () => {
        if (count-- <= 0) return resolve();
        requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    });
  }

  async function refreshCartUI() {
    const sectionHandles = ['ajax-cart', 'cart-drawer', 'cart-icon-bubble'];
    const url = `/?sections=${encodeURIComponent(sectionHandles.join(','))}`;
    const res = await fetch(url, { headers: { 'Accept': 'application/json' } });
    if (!res.ok) return;

    const sections = await res.json();

    if (sections['ajax-cart']) {
      const holder = qs('[data-section="ajax-cart"], #shopify-section-ajax-cart');
      if (holder) holder.innerHTML = sections['ajax-cart'];
    }
    if (sections['cart-drawer']) {
      const drawer = qs('#shopify-section-cart-drawer');
      if (drawer) drawer.innerHTML = sections['cart-drawer'];
    }
    if (sections['cart-icon-bubble']) {
      const bubble = qs('#shopify-section-cart-icon-bubble');
      if (bubble) bubble.innerHTML = sections['cart-icon-bubble'];
    }

    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  function openCartDrawerOrCartPage() {
    const drawer =
      qs('cart-drawer') ||
      qs('[data-cart-drawer]') ||
      qs('#CartDrawer') ||
      qs('.cart-drawer');

    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }

    const openBtn = qs('[data-cart-drawer-open], .cart-drawer-toggle, a[href="/cart"]');
    if (openBtn) {
      openBtn.click();
      return;
    }

    window.location.href = '/cart';
  }

  function getVariantIdSmart(form, productFormEl, section) {
    let el = qs('[name="id"]', form) || qs('[name="id"]', productFormEl) || qs('[name="id"]', section);
    if (!el) return null;

    if (el.type === 'radio') {
      const checked = qs('[name="id"]:checked', section);
      return checked ? Number(checked.value) : null;
    }

    return el.value ? Number(el.value) : null;
  }

  function getQuantity(form) {
    const qty = parseInt(qs('[name="quantity"]', form)?.value || '1', 10);
    return qty > 0 ? qty : 1;
  }

  function collectLineItemProperties(form) {
    const props = {};
    qsa('[name^="properties["]', form).forEach((el) => {
      const key = el.name?.match(/^properties\[(.*)\]$/)?.[1];
      if (!key) return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      if (el.value) props[key] = el.value.trim();
    });
    return props;
  }

  function init(section) {
    const giftWraps = qsa('[data-gift-addon]', section);
    if (!giftWraps.length) return;

    giftWraps.forEach((giftWrap) => {
      const checkbox = qs('[data-gift-checkbox]', giftWrap);
      const noteWrap = qs('[data-gift-note-wrap]', giftWrap);

      if (!checkbox) return;

      checkbox.addEventListener('change', () => {
        if (noteWrap) {
          noteWrap.classList.toggle('hidden', !checkbox.checked);
        }
      });
    });

    const productFormEl = qs('product-form', section);
    const form = productFormEl ? qs('form', productFormEl) : null;
    if (!form) return;

    async function addMainPlusGifts(goCheckout = false) {
      const variantId = getVariantIdSmart(form, productFormEl, section);
      if (!variantId) {
        alert('Please select a variant first.');
        return;
      }

      const qty = getQuantity(form);
      const props = collectLineItemProperties(form);

      const items = [
        {
          id: variantId,
          quantity: qty,
          ...(Object.keys(props).length ? { properties: props } : {})
        }
      ];

      giftWraps.forEach((giftWrap, index) => {
        const checkbox = qs('[data-gift-checkbox]', giftWrap);
        const noteField = qs('[data-gift-note]', giftWrap);
        const giftVariantId = Number(giftWrap.dataset.giftVariantId);

        if (!checkbox || !checkbox.checked || !giftVariantId) return;

        const giftNote = noteField?.value?.trim() || '';

        items.push({
          id: giftVariantId,
          quantity: 1,
          properties: {
            "_is_gift": "true",
            "_gift_source": `gift-addon-${index + 1}`,
            ...(giftNote ? { "Gift Note": giftNote } : {})
          }
        });
      });

      await addItems(items);

      if (goCheckout) {
        window.location.href = '/checkout';
        return;
      }

      await refreshCartUI();
      openCartDrawerOrCartPage();
    }

    form.addEventListener('submit', async (e) => {
      const hasCheckedGift = giftWraps.some((giftWrap) => {
        const checkbox = qs('[data-gift-checkbox]', giftWrap);
        return checkbox && checkbox.checked;
      });

      if (!hasCheckedGift) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation?.();

      try {
        await addMainPlusGifts(false);
      } catch (err) {
        console.error(err);
        alert(err.message);
      }
    }, true);

    section.addEventListener('click', async (e) => {
      const hasCheckedGift = giftWraps.some((giftWrap) => {
        const checkbox = qs('[data-gift-checkbox]', giftWrap);
        return checkbox && checkbox.checked;
      });

      if (!hasCheckedGift) return;

      const payBtn =
        e.target.closest('.shopify-payment-button__button') ||
        e.target.closest('button[name="checkout"]');

      if (!payBtn) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation?.();

      try {
        await waitNextFrames(2);
        await addMainPlusGifts(true);
      } catch (err) {
        console.error(err);
        alert(err.message);
      }
    }, true);
  }

  function boot() {
    qsa('section[data-main-product]').forEach(init);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot)
    : boot();
})();